import type { TasProgramTemplateInstitution } from './tas-program-template-institution.type.ts';
export interface TasProgramTemplateInstitutionExtension extends TasProgramTemplateInstitution {}
export class TasProgramTemplateInstitutionExtension {
  /*************************
   **  Computed Properties **
   *************************/
  get locationName() {
    return (
      this.accreditedInstitution?.locationName || this.unaccreditedInstitution?.locationName || ''
    );
  }
}

const Registration = {
  kind: 'object',
  name: 'tas-program-template-institution',
  features: TasProgramTemplateInstitutionExtension,
};
export default Registration;
